export const updateExtremas = (extremas, x, y) => {
    if (x < extremas[0]) {
        extremas[0] = x;
    }
    if (y < extremas[1]) {
        extremas[1] = y;
    }
    if (x > extremas[2]) {
        extremas[2] = x;
    }
    if (y > extremas[3]) {
        extremas[3] = y;
    }
};
export const getPointsExtremas = (points) => {
    if (!points || !points.length) {
        return [0, 0, 0, 0];
    }
    const [firstPoint] = points;
    return points.reduce((extremas, { x, y }) => {
        updateExtremas(extremas, x, y);
        return extremas;
    }, [firstPoint.x, firstPoint.y, firstPoint.x, firstPoint.y]);
};
export const getExtremasBounds = (extremas) => ({
    x: Math.min(extremas[0], extremas[2]),
    y: Math.min(extremas[1], extremas[3]),
    width: Math.abs(extremas[2] - extremas[0]),
    height: Math.abs(extremas[3] - extremas[1]),
});
